<div class="alain-default__aside-inner">
  <!-- <app-wallet></app-wallet> -->
  <layout-default-nav class="d-block py-lg"></layout-default-nav>
</div>
